
import '../App.css';
import React, {useState, useEffect} from 'react';




function Login() {

    const [username, setUsername] = useState("");
    const [step, setStep] = useState(1); 
    const [key, setKey] = useState(""); 

    const onUsernameSubmit = (e) => {
        e.preventDefault();
        if (username.length < 3) {
            alert("Username must be at least 3 characters long.");
            return;
        }
        setStep(2);
        
    }

    const onKeySubmit = (e) => { // UNSUPPORTED MEDIA TYPE ROBLOX API ERROR
        
        e.preventDefault();
        fetch('https://api.allorigins.win/raw?url=https://users.roblox.com/v1/usernames/users', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ usernames: [username] }),
            mode: 'cors',
          })
            .then(res => res.json())
            .then(data => {
              // Debug the response to inspect its structure
              console.log('Response from Roblox API (Usernames API):', data);
          
              // Ensure data is structured as expected (data.data should exist)
              if (data.data && data.data.length > 0) {
                const userId = data.data[0].id;  // Extracting the user ID
                return fetch(`https://api.allorigins.win/raw?url=https://users.roblox.com/v1/users/${userId}`);
              } else {
                throw new Error('User not found');
              }
            })
            .then(res => res.json())
            .then(user => {
              const bio = user.description;
              if (bio && bio.includes(key)) {
                console.log("✅ User verified successfully!");
              } else {
                console.log("❌ User not verified!");
              }
            })
            .catch(err => console.error("Error:", err));
                
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(key)
    }

    useEffect(() => {
        const randomKey = Math.random().toString(36).substring(2, 10).toUpperCase();
        setKey(randomKey);
    }, []); 


  return (
    <>
        <br />
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <hr className="my-2" />
        <h3>Zanances USAR</h3>
        <h1>503rd Battalion</h1>
        <hr className="my-4" />
        </div>
        {step === 1 && (
            <div className="card" style={{width: "18rem", margin: "auto"}}>
                <div className="card-body" style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                    <h5 className="card-title">Login</h5>
                    <form style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}} onSubmit={(e) => {onUsernameSubmit(e)}}>
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1">@</span>
                            <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={username} onChange={e => {setUsername(e.target.value)}}/> 
                        </div>
                        <button type="submit" className="btn btn-outline-primary">Submit</button>
                    </form>
                    
                </div>
            </div>
        )}
        {step === 2 && (
            
            <div className="card" style={{width: "18rem", margin: "auto"}}>
                <div className="card-body" style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                    <h5 className="card-title">Login</h5>
                    <form style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}} onSubmit={(e) => {onKeySubmit(e)}}>
                        <p>Add the following code to your roblox profile description:</p>
                        <div className="input-group mb-3">
                            
                            <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={key} onChange={(e) => (setKey(e.target.value))} disabled/> 
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" onClick={copyToClipboard}>Copy</button>
                        </div>
                        <button type="submit" className="btn btn-outline-primary">Done</button>
                    </form>
                    
                </div>
            </div>
        )}
        
        
    </>
  );
}

export default Login;
